import BlurredCell from '../../BlurredCell';
import styles from './card-sections.module.css';

interface ProfileNameProps {
  firstName: string;
  lastName: string;
  isTrialUser?: boolean;
  encryptedLastName?: string;
  userKey?: string;
  onBlurHover?: () => void;
}

const noop = () => undefined;

export const ProfileName = ({
  firstName,
  lastName,
  isTrialUser = false,
  encryptedLastName,
  userKey,
  onBlurHover,
}: ProfileNameProps) => {
  return (
    <p className={styles.profileName}>
      <span data-testid="card-first-name">{firstName}</span>{' '}
      {isTrialUser && lastName.trim().length > 0 ? (
        <span className={styles.blurredName}>
          <BlurredCell
            value={lastName}
            encryptedValue={encryptedLastName}
            onMouseEnter={onBlurHover ?? noop}
            allowUnblur={false}
            isCompact={false}
            userKey={userKey}
            fieldKey="last_name"
            data-testid="card-last-name"
          />
        </span>
      ) : (
        <span data-testid="card-last-name">{lastName}</span>
      )}
    </p>
  );
};
